import { render, staticRenderFns } from "./Sendsms.vue?vue&type=template&id=873471b8&"
import script from "./Sendsms.vue?vue&type=script&lang=js&"
export * from "./Sendsms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports